import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild, inject } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { fadeInAnimation } from 'src/app/animations/fade-in-animation';
import { MenuService } from 'src/app/services/menu/menu.service';
import { UserDataService } from 'src/app/services/userData/user-data.service';
import { UtilService } from 'src/app/services/util/util.service';
import { SpanHtmlComponent } from '../span-html/span-html.component';

@Component({
    selector: 'app-cookie-message',
    templateUrl: './cookie-message.component.html',
    animations: [fadeInAnimation],
    styleUrls: ['./cookie-message.component.scss'],
    imports: [ModalDirective, SpanHtmlComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieMessageComponent {
  ud = inject(UserDataService);
  util = inject(UtilService);
  menu = inject(MenuService);
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('slideRight') slideRight: ModalDirective;
  policyText: any;
  show() {
    this.ud.getCookiePolicy().subscribe((data: any) => {
      if (this.menu && this.menu.loggedUser && this.menu.loggedUser.preferredLocale) {
        if (this.menu.loggedUser.preferredLocale.indexOf('es') !== -1 && data.textEs) {
          this.policyText = data.textEs;
        } else if (this.menu.loggedUser.preferredLocale.indexOf('en') !== -1 && data.textEn) {
          this.policyText = data.textEn;
        } else if (this.menu.loggedUser.preferredLocale.indexOf('pt-PT') !== -1 && data.textPt) {
          this.policyText = data.textPt;
        } else {
          this.policyText = data.text;
        }
      } else {
        if (navigator.language.indexOf('es') !== -1 && data.textEs) {
          this.policyText = data.textEs;
        } else if (navigator.language.indexOf('en') !== -1 && data.textEn) {
          this.policyText = data.textEn;
        } else if (navigator.language.indexOf('pt-BR') !== -1 && data.text) {
          this.policyText = data.text;
        } else if (navigator.language == 'pt' && data.textPt) {
          this.policyText = data.textPt;
        } else {
          this.policyText = data.text;
        }
      }
      this.cdr.markForCheck();
    });
    this.slideRight.show();
  }

}
